import React from 'react';

import Header from '../../layout/Header.jsx';
import ListViewSlots from '../../lists/ListViewSlots.jsx';

const PageViewSlots = () => (
  <div>
    <Header>Site</Header>
    <ListViewSlots />
  </div>
);

export default PageViewSlots;
